import { useState } from "react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import md5 from "md5";
// Redux
import { useSelector } from "react-redux";
// Constants - Functions
import { WEB_SERVICE_MIMS } from "../../config/constants";
import { passwordValidation } from "../../config/functions";
// Components
import {
  ChangePasswordForm,
  TitleTextDiv,
  TextDiv,
  TextP,
  DataDiv,
  ColumnDataDiv,
  InputDataDiv,
  Label,
  Input,
  SaveDiv,
  SaveButton,
} from "./styles";
import Axios from "../../config/axios";
import Title from "../title";

const Settings = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const clinicianData = useSelector(({ clinician }) => clinician.data);
  const [t] = useTranslation("global");

  const handleUpdatePassword = (e) => {
    e.preventDefault();
    if (currentPassword === "" || newPassword === "" || confirmPassword === "") {
      return toast.error(t("emptyDataMessage"));
    }
    if (!passwordValidation(newPassword)) {
      return toast.error(t("settings_passwordSection_passwordValidationMessage"));
    }
    if (newPassword !== confirmPassword) {
      return toast.error(t("settings_passwordSection_confirmPasswordMessage"));
    }
    Axios("post", `${WEB_SERVICE_MIMS}/clinicians/update-password/${clinicianData.CLINICIAN_ID}`, {
      currentPassword: md5(`${clinicianData.CLINICIAN_USER}${currentPassword}`),
      newPassword: md5(`${clinicianData.CLINICIAN_USER}${newPassword}`),
    })
      .then(({ data }) => {
        if (data.incorrectPassword) {
          return toast.error(t("settings_passwordSection_incorrectPasswordMessage"));
        }
        if (data.passwordUpdated) {
          setCurrentPassword("");
          setNewPassword("");
          setConfirmPassword("");
          return toast.success(t("settings_passwordSection_passwordUpdatedMessage"));
        }
        return toast.error(t("emptyDataMessage"));
      })
      .catch((error) => {
        console.log("url error: ", error);
        return toast.error(t("emptyDataMessage"));
      });
  };

  return (
    <>
      <Title title={t("settings").toUpperCase()} marginBottom="15px" />
      <ChangePasswordForm>
        <TitleTextDiv>
          <TextP>{t("settings_passwordSection_title")}</TextP>
        </TitleTextDiv>
        <TextDiv>
          <TextP>{t("settings_passwordSection_confirmChangeText")}</TextP>
        </TextDiv>
        <DataDiv>
          <ColumnDataDiv>
            <InputDataDiv>
              <Label htmlFor="currentPassword" fontWeight="bold">
                {t("settings_passwordSection_currentPassword")} *
              </Label>
              <Input
                type="password"
                placeholder="*******"
                id="currentPassword"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value.replace(/\s+/g, ""))}
              />
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="newPassword" fontWeight="bold">
                {t("settings_passwordSection_newPassword")} *
              </Label>
              <Input
                type="password"
                placeholder="*******"
                id="newPassword"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value.replace(/\s+/g, ""))}
              />
            </InputDataDiv>
            <InputDataDiv>
              <Label htmlFor="confirmPassword" fontWeight="bold">
                {t("settings_passwordSection_confirmNewPassword")} *
              </Label>
              <Input
                type="password"
                placeholder="*******"
                id="confirmPassword"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value.replace(/\s+/g, ""))}
              />
            </InputDataDiv>
          </ColumnDataDiv>
        </DataDiv>
        <SaveDiv>
          <SaveButton onClick={handleUpdatePassword}>{t("save")}</SaveButton>
        </SaveDiv>
      </ChangePasswordForm>
    </>
  );
};

export default Settings;
